import { getField, updateField } from 'vuex-map-fields';

export default {
  name: 'TrustSignerStatus',
  namespaced: true,
  state: {
    envelopeId: '',
    signer: [],
  },
  getters: {
    getField,
    TrustSignerStatus: (state) => state,
  },
  mutations: {
    updateField,
  },
};
